export default "__VITE_ASSET__iVNqCMk9__"